import { WasThisUsefulService } from '../services/was-this-useful-service';
var WasThisUsefulProvider = /** @class */ (function () {
    function WasThisUsefulProvider() {
        var _this = this;
        this.$get = [
            '$http',
            function ($http) {
                return new WasThisUsefulService($http, _this.baseUrlValue || '', _this.marketLocaleValue || '', _this.siteContextValue || '');
            },
        ];
    }
    WasThisUsefulProvider.prototype.baseUrl = function (baseUrl) {
        if (baseUrl) {
            this.baseUrlValue = baseUrl;
            return this;
        }
        else {
            return this.baseUrlValue;
        }
    };
    WasThisUsefulProvider.prototype.marketLocale = function (marketLocale) {
        if (marketLocale) {
            this.marketLocaleValue = marketLocale;
            return this;
        }
        else {
            return this.marketLocaleValue;
        }
    };
    WasThisUsefulProvider.prototype.siteContext = function (siteContext) {
        if (siteContext) {
            this.siteContextValue = siteContext;
            return this;
        }
        else {
            return this.siteContextValue;
        }
    };
    return WasThisUsefulProvider;
}());
export { WasThisUsefulProvider };
